module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/elo-logo-78f1d574a9028e1d9fc4d58bc09e782b.svg";